/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/12/21
 * Copyright All Rights Reserved
 */
import { pick } from 'lodash/fp';
import {
  FETCH_ACTION,
  FETCH_INVENTORIES_REQUEST,
  FETCH_INVENTORIES_RESPONSE,
  FETCH_INVENTORY_REQUEST,
  FETCH_INVENTORY_RESPONSE,
} from 'constants/actionTypes';
import { selectResultsGroupIsCached } from 'selectors/entities/inventories';
import getParamsString from 'support/getParamsString';
import { analysisTypesById } from '../constants/analysisTypes';

export const fetchInventories = orgId => ({
  [FETCH_ACTION]: {
    types: [FETCH_INVENTORIES_REQUEST, FETCH_INVENTORIES_RESPONSE],
    endpoint: `/org/${orgId}/inventory`,
    options: {
      method: 'GET',
    },
    dataTransform: json => json,
  },
});

const filterParams = (analysisType, searchParams) => (
  pick(analysisTypesById[analysisType].searchParams, searchParams)
);

const fetchInventory = (
  inventoryId,
  analysisType,
  searchParams,
) => ({
  [FETCH_ACTION]: {
    types: [FETCH_INVENTORY_REQUEST, FETCH_INVENTORY_RESPONSE],
    endpoint: `/inventory/${inventoryId}/analysisType/${analysisType}?${getParamsString(filterParams(analysisType, searchParams))}`,
    options: {
      method: 'GET',
    },
    dataTransform: json => json,
  },
});

export const fetchInventoryIfNotCached = (
  inventoryId,
  analysisType,
  searchParams
) => (dispatch, getState) => {
  const state = getState();
  const filteredParams = filterParams(analysisType, searchParams);
  const groupIsCached = selectResultsGroupIsCached(
    state,
    {
      inventoryId,
      analysisType,
      ...filteredParams,
    }
  );
  if (groupIsCached) {
    return Promise.resolve();
  }
  return dispatch(fetchInventory(inventoryId, analysisType, searchParams));
};



// WEBPACK FOOTER //
// ./js/actions/inventoryCreators.js